import { bl_ppl_to_xap_submission_history_RowClass } from '../../../dbschema/bl_ppl_to_xap_submission_history.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolToXAPSubmissionHistoryContainerModel extends BaseContainerModel {
    bl_ppl_to_xap_submission_history: bl_ppl_to_xap_submission_history_RowClass = new bl_ppl_to_xap_submission_history_RowClass();
}
